export default __webpack_public_path__ + "static/media/size.c69406b0.svg";